import { render, staticRenderFns } from "./SimilarBrandsPreview.vue?vue&type=template&id=fdfd1a30&scoped=true"
import script from "./SimilarBrandsPreview.vue?vue&type=script&lang=js"
export * from "./SimilarBrandsPreview.vue?vue&type=script&lang=js"
import style0 from "./SimilarBrandsPreview.vue?vue&type=style&index=0&id=fdfd1a30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfd1a30",
  null
  
)

export default component.exports